export default "__VITE_ASSET__gwnAiGHi__"